import React, { useState, useEffect } from 'react';
import { Link, Outlet, useLocation } from 'react-router-dom';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const AdminLayout = () => {
  const location = useLocation();
  const [stats, setStats] = useState(null);
  const [sidebarOpen, setSidebarOpen] = useState(true);

  useEffect(() => {
    fetchStats();
  }, []);

  const fetchStats = async () => {
    try {
      const res = await fetch(`${API_URL}/api/admin/stats`);
      const data = await res.json();
      setStats(data);
    } catch (err) {
      console.error('Error fetching stats:', err);
    }
  };

  const menuItems = [
    { path: '/admin', label: 'Dashboard', icon: 'fa-gauge-high', exact: true },
    { path: '/admin/hero-images', label: 'Hero Images', icon: 'fa-images' },
    { path: '/admin/destinations', label: 'Destinations', icon: 'fa-map-location-dot' },
    { path: '/admin/handpicked', label: 'Handpicked', icon: 'fa-star' },
    { path: '/admin/last-minute-deals', label: 'Last Minute Deals', icon: 'fa-fire' },
    { path: '/admin/early-bird-deals', label: 'Early Bird Deals', icon: 'fa-clock' },
    { path: '/admin/travel-stories', label: 'Travel Stories', icon: 'fa-comments' },
    { path: '/admin/inquiries', label: 'Inquiries', icon: 'fa-envelope' },
    { path: '/admin/packages', label: 'Packages', icon: 'fa-box' },
    { path: '/admin/announcement', label: 'Announcement', icon: 'fa-bullhorn' },
    { path: '/admin/settings', label: 'Site Settings', icon: 'fa-gear' },
  ];

  const isActive = (path, exact = false) => {
    if (exact) return location.pathname === path;
    return location.pathname.startsWith(path);
  };

  return (
    <div className="admin-layout">
      {/* Sidebar */}
      <aside className={`admin-sidebar ${sidebarOpen ? 'open' : 'closed'}`}>
        <div className="admin-sidebar-header">
          <Link to="/" className="admin-logo">
            <i className="fa-solid fa-plane"></i>
            <span>Elite Experiences</span>
          </Link>
          <button onClick={() => setSidebarOpen(!sidebarOpen)} className="sidebar-toggle">
            <i className={`fa-solid ${sidebarOpen ? 'fa-chevron-left' : 'fa-chevron-right'}`}></i>
          </button>
        </div>

        <nav className="admin-nav">
          {menuItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={`admin-nav-item ${isActive(item.path, item.exact) ? 'active' : ''}`}
            >
              <i className={`fa-solid ${item.icon}`}></i>
              <span>{item.label}</span>
            </Link>
          ))}
        </nav>

        <div className="admin-sidebar-footer">
          <Link to="/" className="admin-back-link">
            <i className="fa-solid fa-arrow-left"></i>
            <span>Back to Website</span>
          </Link>
        </div>
      </aside>

      {/* Main Content */}
      <main className="admin-main">
        <Outlet context={{ stats, refreshStats: fetchStats }} />
      </main>
    </div>
  );
};

export default AdminLayout;
